// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_6w-0";
export var orangeButton = "_6w-1";